import React, { Component } from 'react';
import { Route } from 'react-router';
import { Home } from './components/Home';

export default class App extends Component {
  static displayName = App.name;

    render() {

        var path = [];
        if (process.env.REACT_APP_HYPERDRIVE_MODE === 'true' && process.env.NODE_ENV === 'development') {
            path.push(<Route path='/Databay' component={Home} />);
        }
        else {
            path.push(<Route path='/' component={Home} />);
        }
    return (
        <span id="contentBody" className="contentBody">
            {path}
        </span>
    );
  }
}
